/*
 *
 * CreatePayByLinkPlus Actions
 *
 * @version 1.0.0
 * @author Magarelli-Fabrizio
 * @since 20-Nov-2024
 */

import { createRequestTypes, createAction, MakeRequest } from 'Store/actions/index'

export const actionTypes = {
  DO_GET_PAY_BY_LINK_TERMINAL_ID_LIST: '@@CreatePayByLinkPlus/get_pay_by_link_terminal_id_list',
  DO_GENERATE_PAY_BY_LINK: '@@CreatePayByLinkPlus/generate_pay_by_link',
  DO_RESET_PBL_GENERATE_RESULT: '@@CreatePayByLinkPlus/reset_pbl_generate_result',
  DO_SET_ADVANCED_REQ_STEP: '@@CreatePayByLinkPlus/set_advanced_req_step',
  DO_RETIVE_PAYMENT_SETTINGS_LIST: '@@CreatePayByLinkPlus/retive_payment_settings_list',
  DO_PBL_SEND_DIRECT_EMAIL_SMS: '@@CreatePayByLinkPlus/pbl_send_direct_email_sms',
  DO_RETRIEVE_PBL_QRCODE: '@@CreatePayByLinkPlus/retrieve_pbl_qrcode',
  DO_SET_QR_CODE_TOAST_MESSAGE: '@@CreatePayByLinkPlus/set_qr_code_toast_message',
  DO_GET_PBL_TERMINAL_CURRENCIES: '@@CreatePayByLinkPlus/get_pbl_terminal_currencies',
  // @generator action:route:type
  ...createRequestTypes('@@CreatePayByLinkPlus', 'RETRIVE_PAY_BY_LINK_TERMINAL_ID_LIST'),
  ...createRequestTypes('@@CreatePayByLinkPlus', 'GENERATE_PAY_BY_LINK'),
  ...createRequestTypes('@@CreatePayByLinkPlus', 'RETRIVE_PAYMENT_SETTINGS_LIST'),
  ...createRequestTypes('@@CreatePayByLinkPlus', 'GENERATE_PBL_DIRECT_EMAIL_SMS'),
  ...createRequestTypes('@@CreatePayByLinkPlus', 'GENERATE_PBL_QRCODE'),
  ...createRequestTypes('@@CreatePayByLinkPlus', 'GET_PBL_TERMINAL_CURRENCIES')
  // @generator action:route:type:request
}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:route:request
/** @action request
 * * Insert a description
 * @name getPblTerminalCurrencies
 * @return {object} - The action object
 */
export const getPblTerminalCurrencies = new MakeRequest('CreatePayByLinkPlus', 'get_pbl_terminal_currencies')
/** @action request
 * * Insert a description
 * @name generatePblQrcode
 * @return {object} - The action object
 */
export const generatePblQrcode = new MakeRequest('CreatePayByLinkPlus', 'generate_pbl_qrcode')
/** @action request
 * * Insert a description
 * @name generatePblDirectEmailSms
 * @return {object} - The action object
 */
export const generatePblDirectEmailSms = new MakeRequest('CreatePayByLinkPlus', 'generate_pbl_direct_email_sms')
/** @action request
 * * Insert a description
 * @name retrivePaymentSettingsList
 * @return {object} - The action object
 */
export const retrivePaymentSettingsList = new MakeRequest('CreatePayByLinkPlus', 'retrive_payment_settings_list')
/** @action request
 * * Insert a description
 * @name generatePayByLink
 * @return {object} - The action object
 */
export const generatePayByLink = new MakeRequest('CreatePayByLinkPlus', 'generate_pay_by_link')
/** @action request
 * * Insert a description
 * @name retrivePayByLinkTerminalIdList
 * @return {object} - The action object
 */
export const retrivePayByLinkTerminalIdList = new MakeRequest(
  'CreatePayByLinkPlus',
  'retrive_pay_by_link_terminal_id_list'
)
// @generator action:route
/** @action
 * * Insert a description
 * @name SetQrCodeToastMessage
 * @return {object} - The payload object
 */
export const doSetQrCodeToastMessage = (payload) => createAction(actionTypes.DO_SET_QR_CODE_TOAST_MESSAGE, { payload })
/** @action
 * * Insert a description
 * @name RetrievePblQrcode
 * @return {object} - The payload object
 */
export const doRetrievePblQrcode = (payload) => createAction(actionTypes.DO_RETRIEVE_PBL_QRCODE, { payload })
/** @action
 * * Insert a description
 * @name PblSendDirectEmailSms
 * @return {object} - The payload object
 */
export const doPblSendDirectEmailSms = (payload) => createAction(actionTypes.DO_PBL_SEND_DIRECT_EMAIL_SMS, { payload })
/** @action
 * * Insert a description
 * @name RetivePaymentSettingsList
 * @return {object} - The payload object
 */
export const doRetivePaymentSettingsList = (payload) =>
  createAction(actionTypes.DO_RETIVE_PAYMENT_SETTINGS_LIST, { ...payload })
/** @action
 * * Insert a description
 * @name SetAdvancedRequestStep
 * @return {object} - The payload object
 */
export const doSetAdvancedRequestStep = (payload) => createAction(actionTypes.DO_SET_ADVANCED_REQ_STEP, { payload })
/** @action
 * * Insert a description
 * @name ResetPblGenerateResult
 * @return {object} - The payload object
 */
export const doResetPblGenerateResult = (payload) => createAction(actionTypes.DO_RESET_PBL_GENERATE_RESULT, { payload })
/** @action
 * * Insert a description
 * @name GeneratePayByLink
 * @return {object} - The payload object
 */
export const doGeneratePayByLink = (payload) => createAction(actionTypes.DO_GENERATE_PAY_BY_LINK, { payload })
/** @action
 * * Insert a description
 * @name GetPblTerminalCurrencies
 * @return {object} - The payload object
 */
export const doGetPblTerminalCurrencies = (payload) =>
  createAction(actionTypes.DO_GET_PBL_TERMINAL_CURRENCIES, { payload })
/** @action
 * * Insert a description
 * @name GetPayByLinkTerminalIdList
 * @return {object} - The payload object
 */
export const doGetPayByLinkTerminalIdList = (payload) =>
  createAction(actionTypes.DO_GET_PAY_BY_LINK_TERMINAL_ID_LIST, { payload })
